import Vue from 'vue';
import store from 'store';
import md5 from 'md5';

export default {
    async getData(url, urlParameters) {
        const response = await Vue.http.get(url, { params: urlParameters });

        return response.body;
    },
    getCached(url, forceFetch = false) {
        let key = md5(url);
        let val = store.get(key);
        if (!val || forceFetch) {
            return this.getData(url).then((data) => {
                store.set(key, data);
                return data;
            });
        }

        return new Promise((resolve) => {
            return resolve(val);
        });
    }
};
